/*
 * AMY B. — Size Finder: popup "Trova la tua taglia" (altezza/peso -> taglia consigliata).
 * Il modal viene iniettato nel <body> per evitare problemi di z-index con le immagini prodotto.
 * Si apre dai bottoni [data-size-finder-open] (snippet product-size-tools).
 */
(function() {
  if (window.amybOpenModal) return;

  var amybSelectedCat = null;
  var modalInjected = false;

  function injectModal() {
    if (modalInjected) return;
    modalInjected = true;

    var modalHTML = '<div id="amyb-size-modal" onclick="if(event.target===this)amybCloseModal()" style="display:none;position:fixed;inset:0;background:rgba(0,0,0,0.55);z-index:2147483647;align-items:center;justify-content:center;padding:16px;box-sizing:border-box;">'
      + '<div style="background:#fff;border-radius:12px;width:100%;max-width:440px;max-height:90vh;overflow-y:auto;padding:28px 24px 32px;box-sizing:border-box;position:relative;font-family:inherit;">'

      + '<div style="display:flex;align-items:center;justify-content:space-between;margin-bottom:6px;">'
      + '<p style="margin:0;font-size:11px;letter-spacing:0.1em;color:#999;text-transform:uppercase;">Guida alle taglie</p>'
      + '<button onclick="amybCloseModal()" style="background:none;border:none;cursor:pointer;padding:4px;color:#999;font-size:22px;line-height:1;">&#215;</button>'
      + '</div>'

      + '<h2 style="margin:0 0 6px;font-size:22px;font-weight:500;color:#111;">Trova la tua taglia</h2>'
      + '<p style="margin:0 0 24px;font-size:13px;color:#888;line-height:1.6;">Inserisci la tua altezza e il tuo peso. Ti diremo subito quale taglia AMY B. fa per te.</p>'

      + '<div style="display:grid;grid-template-columns:1fr 1fr;gap:12px;margin-bottom:16px;">'
      + '<div><label style="font-size:11px;letter-spacing:0.08em;color:#999;text-transform:uppercase;display:block;margin-bottom:6px;">Altezza (cm)</label>'
      + '<input type="number" id="amyb-height" min="145" max="185" placeholder="es. 168" style="width:100%;box-sizing:border-box;padding:10px 12px;font-size:15px;border:1px solid #ddd;border-radius:8px;color:#111;background:#fff;font-family:inherit;outline:none;" onfocus="this.style.borderColor=\'#111\'" onblur="this.style.borderColor=\'#ddd\'"></div>'
      + '<div><label style="font-size:11px;letter-spacing:0.08em;color:#999;text-transform:uppercase;display:block;margin-bottom:6px;">Peso (kg)</label>'
      + '<input type="number" id="amyb-weight" min="40" max="110" placeholder="es. 62" style="width:100%;box-sizing:border-box;padding:10px 12px;font-size:15px;border:1px solid #ddd;border-radius:8px;color:#111;background:#fff;font-family:inherit;outline:none;" onfocus="this.style.borderColor=\'#111\'" onblur="this.style.borderColor=\'#ddd\'"></div>'
      + '</div>'

      + '<div style="margin-bottom:20px;">'
      + '<label style="font-size:11px;letter-spacing:0.08em;color:#999;text-transform:uppercase;display:block;margin-bottom:10px;">Tipologia capo</label>'
      + '<div style="display:flex;flex-wrap:wrap;gap:8px;">'
      + '<button onclick="amybSelectCat(\'abiti\')"     id="amyb-btn-abiti"     style="font-size:13px;padding:7px 14px;border-radius:999px;border:1px solid #ddd;background:#fff;color:#555;cursor:pointer;font-family:inherit;transition:all 0.15s;">Abiti</button>'
      + '<button onclick="amybSelectCat(\'camicie\')"   id="amyb-btn-camicie"   style="font-size:13px;padding:7px 14px;border-radius:999px;border:1px solid #ddd;background:#fff;color:#555;cursor:pointer;font-family:inherit;transition:all 0.15s;">Camicie e bluse</button>'
      + '<button onclick="amybSelectCat(\'maglieria\')" id="amyb-btn-maglieria" style="font-size:13px;padding:7px 14px;border-radius:999px;border:1px solid #ddd;background:#fff;color:#555;cursor:pointer;font-family:inherit;transition:all 0.15s;">Maglieria</button>'
      + '<button onclick="amybSelectCat(\'pantaloni\')" id="amyb-btn-pantaloni" style="font-size:13px;padding:7px 14px;border-radius:999px;border:1px solid #ddd;background:#fff;color:#555;cursor:pointer;font-family:inherit;transition:all 0.15s;">Pantaloni</button>'
      + '</div></div>'

      + '<button onclick="amybCalculate()" style="width:100%;padding:14px;font-size:13px;letter-spacing:0.1em;text-transform:uppercase;background:#111;color:#fff;border:none;border-radius:8px;cursor:pointer;font-family:inherit;margin-bottom:16px;">Scopri la mia taglia</button>'

      + '<div id="amyb-result" style="display:none;border:1px solid #eee;border-radius:10px;padding:18px 20px;background:#fafafa;">'
      + '<p style="font-size:11px;letter-spacing:0.1em;color:#999;text-transform:uppercase;margin:0 0 6px;">La tua taglia AMY B.</p>'
      + '<p id="amyb-result-size" style="font-size:40px;font-weight:500;color:#111;margin:0 0 6px;line-height:1;"></p>'
      + '<p id="amyb-result-note" style="font-size:13px;color:#666;margin:0;line-height:1.6;"></p>'
      + '</div>'

      + '<div id="amyb-error" style="display:none;border:1px solid #f5c2c2;border-radius:8px;padding:12px 16px;background:#fff5f5;">'
      + '<p id="amyb-error-msg" style="font-size:13px;color:#c0392b;margin:0;"></p>'
      + '</div>'

      + '<p style="font-size:11px;color:#bbb;margin:16px 0 0;line-height:1.5;text-align:center;">In caso di dubbio tra due taglie, ti consigliamo di scegliere la taglia più grande.<br>Reso gratuito entro 30 giorni.</p>'

      + '</div></div>';

    document.body.insertAdjacentHTML('beforeend', modalHTML);
  }

  window.amybOpenModal = function() {
    injectModal();
    var modal = document.getElementById('amyb-size-modal');
    modal.style.display = 'flex';
    document.body.style.overflow = 'hidden';
  };

  window.amybCloseModal = function() {
    var modal = document.getElementById('amyb-size-modal');
    if (modal) modal.style.display = 'none';
    document.body.style.overflow = '';
  };

  window.amybSelectCat = function(cat) {
    amybSelectedCat = cat;
    ['abiti','camicie','maglieria','pantaloni'].forEach(function(c) {
      var btn = document.getElementById('amyb-btn-' + c);
      if (!btn) return;
      if (c === cat) {
        btn.style.background = '#111';
        btn.style.color = '#fff';
        btn.style.border = '1px solid #111';
      } else {
        btn.style.background = '#fff';
        btn.style.color = '#555';
        btn.style.border = '1px solid #ddd';
      }
    });
  };

  function showAmybError(msg) {
    document.getElementById('amyb-result').style.display = 'none';
    document.getElementById('amyb-error-msg').textContent = msg;
    document.getElementById('amyb-error').style.display = 'block';
  }

  function showAmybResult(size, note) {
    document.getElementById('amyb-error').style.display = 'none';
    document.getElementById('amyb-result-size').textContent = size;
    document.getElementById('amyb-result-note').textContent = note;
    document.getElementById('amyb-result').style.display = 'block';
  }

  window.amybCalculate = function() {
    var h = parseFloat(document.getElementById('amyb-height').value);
    var w = parseFloat(document.getElementById('amyb-weight').value);

    if (!h || !w) { showAmybError('Inserisci altezza e peso per continuare.'); return; }
    if (h < 145 || h > 185) { showAmybError("Inserisci un'altezza compresa tra 145 e 185 cm."); return; }
    if (w < 40 || w > 110) { showAmybError('Inserisci un peso compreso tra 40 e 110 kg.'); return; }
    if (!amybSelectedCat) { showAmybError('Seleziona il tipo di capo prima di procedere.'); return; }

    var bmi = w / ((h / 100) * (h / 100));
    var size, note;

    if (amybSelectedCat === 'maglieria') {
      showAmybResult('TU', 'La maglieria AMY B. è disponibile in taglia unica — pensata per adattarsi a corporature S, M e L.');
      return;
    }

    if (amybSelectedCat === 'abiti' || amybSelectedCat === 'camicie') {
      if      (h <= 162 && bmi < 20)        { size = 'S';     note = 'La S è la taglia ideale per la tua corporatura. Per una vestibilità più morbida, considera la M.'; }
      else if (h <= 162 && bmi < 24)        { size = 'S / M'; note = 'Sei in zona di confine. Se hai il seno pronunciato preferisci la M, per una vestibilità più aderente scegli la S.'; }
      else if (h <= 162 && bmi >= 24)       { size = 'M / L'; note = 'Ti consigliamo la M. Se preferisci maggiore comodità sul busto, opta per la L.'; }
      else if (h > 162 && h <= 170 && bmi < 21)  { size = 'S'; note = 'La S è la scelta ideale per il tuo fisico.'; }
      else if (h > 162 && h <= 170 && bmi < 25)  { size = 'M'; note = 'La M è la taglia più adatta per la tua corporatura.'; }
      else if (h > 162 && h <= 170 && bmi >= 25) { size = 'L'; note = 'La L garantisce la vestibilità più confortevole.'; }
      else if (h > 170 && bmi < 22)         { size = 'S / M'; note = 'Con la tua altezza la S potrebbe risultare corta — valuta la M per un fit più equilibrato.'; }
      else if (h > 170 && bmi < 26)         { size = 'M';     note = 'La M è la scelta ideale. Attenzione: i modelli corti potrebbero risultare brevi in altezza.'; }
      else                                   { size = 'L';     note = 'La L ti garantirà la vestibilità migliore.'; }
    }

    if (amybSelectedCat === 'pantaloni') {
      if      (w < 52) { size = 'S';     note = 'La S è perfetta per la tua corporatura. Vita capo: 33 cm, fianchi: 44 cm.'; }
      else if (w < 62) { size = 'S';     note = 'La S dovrebbe calzare bene. Se hai i fianchi pronunciati rispetto alla vita, considera la M.'; }
      else if (w < 70) { size = 'M';     note = 'La M è la taglia consigliata. Vita capo: 35 cm, fianchi: 47 cm.'; }
      else if (w < 80) { size = 'M / L'; note = 'Sei in zona di confine. Se hai i fianchi generosi preferisci la L, altrimenti prova la M.'; }
      else             { size = 'L';     note = 'La L è la scelta più comoda. Vita capo: 36 cm, fianchi: 50 cm.'; }
    }

    showAmybResult(size, note);
  };

  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape') amybCloseModal();
  });

  document.addEventListener('click', function(e) {
    if (e.target.closest('[data-size-finder-open]')) amybOpenModal();
  });

})();
